import { render } from "./ExternalRadiologyResultsTab.vue?vue&type=template&id=6859caac&scoped=true"
import script from "./ExternalRadiologyResultsTab.vue?vue&type=script&lang=js"
export * from "./ExternalRadiologyResultsTab.vue?vue&type=script&lang=js"

import "./ExternalRadiologyResultsTab.vue?vue&type=style&index=0&id=6859caac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6859caac"]])

export default __exports__